import CitySEOHead from "@/components/feature/CitySEOHead";
import DunwoodyHeroSection from "./components/HeroSection";
import DunwoodyStickyNav from "./components/StickyNav";
import DunwoodyProcessingTimeSection from "./components/ProcessingTimeSection";
import DunwoodyServicesSection from "./components/ServicesSection";
import DunwoodyLocalAreaSection from "./components/LocalAreaSection";
import DunwoodyTestimonialsSection from "./components/TestimonialsSection";
import DunwoodyAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DunwoodyComparisonSection from "./components/ComparisonSection";
import DunwoodyMistakesSection from "./components/MistakesSection";
import DunwoodyHowItWorksSection from "./components/HowItWorksSection";
import DunwoodyFAQSection, { faqs } from "./components/FAQSection";
import DunwoodyHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DunwoodyFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DunwoodyPage() {
  return (
    <>
      <CitySEOHead
        city="Dunwoody"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/dunwoody"
        title="Emergency Passport Dunwoody, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Dunwoody, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north DeKalb County travelers. Get your emergency passport fast!"
        geoPlacename="Dunwoody, Georgia"
        geoPosition="33.9462;-84.3346"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Dunwoody passport, same day passport Atlanta, fast passport Georgia"
      />
      <div className="font-sans">
        <DunwoodyHeroSection />
        <DunwoodyStickyNav />
        <DunwoodyProcessingTimeSection />
        <DunwoodyLocalAreaSection />
        <DunwoodyServicesSection />
        <DunwoodyTestimonialsSection />
        <DunwoodyAcceptanceFacilitiesSection />
        <DunwoodyComparisonSection />
        <DunwoodyMistakesSection />
        <DunwoodyHowItWorksSection />
        <DunwoodyFAQSection />
        <DunwoodyHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/dunwoody" state="GA" />
        <DunwoodyFinalCTA />
      </div>
    </>
  );
}